// extracted by mini-css-extract-plugin
export default {"section":"Formats_section__CEEY9"};